export const toggle = (list: string[], id: string): string[] =>
  list.includes(id) ? list.filter((i) => i !== id) : [...list, id];

export const toggleMany = (list: string[], targets: string[]): string[] => {
  const allIn = targets.every((id) => list.includes(id));
  return allIn
    ? list.filter((id) => !targets.includes(id))
    : [...new Set([...list, ...targets])];
};
